import { Image, Text } from '$components'
import { ElementType } from 'react'

export type NameCellProps = {
  data: {
    name: string,
    imageUrl: string,
    fallbackIcon: ElementType,
  }
}

export function NameCell({ data }: NameCellProps) {

  return (
    <div className="flex gap-2 items-center w-fit">
      <Image
        src={data.imageUrl}
        alt={data.name}
        size="sm"
        rounding="full"
        fallbackIcon={data.fallbackIcon}
      />

      <Text className="text-sm text-nowrap truncate max-w-32">
        { data.name }
      </Text>
    </div>
  )
}
